export default "__VITE_ASSET__C9bkrgS3__";